module.exports = __webpack_public_path__ + "pc/static/img/all.18d000a7.png";